export default "__VITE_ASSET__b6_b8IsyONwvuMKbSet7KQ__"